import { GenericServiceBase } from '../generic-service';

export type MensagemFixada = {
    id:            string;
    idMensagem:    string;
    idUsuario:     string;
    tipo:          string;
    texto:         string | null;
    url:           string | null;
    global:        boolean;
    dataMensagem:  string;
    dataExpiracao: string;
    // contato
    idInbox?:       string;
    idContato?:     string;
    idAtendimento?: string | null;
    // grupo
    idGrupo?: string;
};

export type CriarFixadaContatoPayload = {
    idInbox:        string;
    idContato:      string;
    idAtendimento?: string | null;
    idMensagem:     string;
    duracao:        '24h' | '7d' | '30d';
    global:         boolean;
};

export type CriarFixadaGrupoPayload = {
    idMensagem: string;
    duracao:    '24h' | '7d' | '30d';
    global:     boolean;
};

export class MensagensFixadasService extends GenericServiceBase {
    constructor() { super('mensagens-fixadas'); }

    async fixarContato(payload: CriarFixadaContatoPayload): Promise<MensagemFixada> {
        return await this.f.post('/contato', payload) as MensagemFixada;
    }

    async listarFixadasContato(params: { idAtendimento?: string; idInbox?: string; idContato?: string }): Promise<MensagemFixada[]> {
        return await this.f.get('/contato', params) as MensagemFixada[];
    }

    async desafixarContato(pinId: string): Promise<void> {
        await this.f.delete(`/contato/${pinId}`);
    }

    async fixarGrupo(idGrupo: string, payload: CriarFixadaGrupoPayload): Promise<MensagemFixada> {
        return await this.f.post(`/grupo/${idGrupo}`, payload) as MensagemFixada;
    }

    async listarFixadasGrupo(idGrupo: string): Promise<MensagemFixada[]> {
        return await this.f.get(`/grupo/${idGrupo}`) as MensagemFixada[];
    }

    async desafixarGrupo(pinId: string): Promise<void> {
        await this.f.delete(`/grupo/${pinId}`);
    }
}
